import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsHistoryGraphsComponent } from './tractors-history-graphs.component';
import {DxChartModule, DxLoadPanelModule, DxToolbarModule} from 'devextreme-angular';
import {DxoValueAxisModule} from 'devextreme-angular/ui/nested';



@NgModule({
  declarations: [TractorsHistoryGraphsComponent],
  imports: [
    CommonModule,
    DxLoadPanelModule,
    DxToolbarModule,
    DxChartModule,
    DxoValueAxisModule
  ],
  exports: [TractorsHistoryGraphsComponent]
})
export class TractorsHistoryGraphsModule { }
